import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Dropdown, Carousel } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import Select from "react-select";
import Drawer from '@mui/material/Drawer';
import DatePicker, { DateObject } from "react-multi-date-picker";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import View from './../../../modal/Accounts_Management/Trial_Balance/View';
// import 'datatables.net-rowgroup';
import axios from 'axios';



 
const Trial_Balance = () => {
    const tableRef = useRef(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [trial, setTrial] = useState([]);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
        const [hasFetched, setHasFetched] = useState(false);
           const [total_credit, settotalCredit] = useState(null);
            const [total_debit, settotalDebit] = useState(null);

  // pagination
            const [page, setPage] = useState(1);
            const [totalPages, setTotalPages] = useState(1);
            const [searchTerm, setSearchTerm] = useState('');
            const [perPage, setPerPage] = useState(10);
            const [total, setTotal] = useState(0);

             const currentDate = new Date(); // Current date: June 18, 2025
    const currentMonth = currentDate.getMonth(); // 5 (June, 0-based index)
            const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ].slice(0, currentMonth + 1);

        // Get current month index (0-11)
        const currentMonthIndex = new Date().getMonth();
            // alert(currentMonthIndex);

        const currentYear = new Date().getFullYear();

        const [index, setIndex] = useState(currentMonth);
        const [month, setMonth] = useState(currentMonth+1);
        const [year, setYear] = useState(currentYear);

        const handleSelect = (selectedIndex) => {
            //  alert(months[currentMonthIndex-1]);
            setIndex(selectedIndex);
             setMonth(selectedIndex+1);
        };
    // const handleModalToggle_View = () => {
    //     setModalType("View");
    //     setOpen(true);
    // };
     const [showModal, setShowModal] = useState(false);
    const [trialbalanceData, setTrailBalanceData] = useState(null);

    const handleModalToggle_View = (dailyAccoundsSno) => {
        setShowModal(true);
        fetchPackageDetails(dailyAccoundsSno);
    };

    const fetchPackageDetails = (sno) => {
            // console.log('Package ID:', id); // Debugging line
            axios.get(`${baseURL}/manage-trial-balance/view/${sno}`)
                .then(response => {
                    setTrailBalanceData(response.data.data);
                })
                .catch(error => {
                    console.error('Error fetching package details', error);
                });
    };

     const handleCloseModal = () => {
        setShowModal(false);
    };

    const onClose = () => {
        setFilterOpen(false);
    };

    // const [index, setIndex] = useState(1);

    // Handle the index change when the user selects a slide
    // const handleSelect = (selectedIndex) => {
    //     setIndex(selectedIndex);
    // };

    useEffect(() => {
    setMonth(months[index]);
    setYear(currentYear); // Or make dynamic if changing years is needed
    // alert(month);
        // alert(page);
     const params = {
                // spread existing filter key-values
             page,           // add page number
             per_page: perPage, // add per_page
             search: searchTerm  // add search string
        };
            axios.get(`${baseURL}/manage-trial-balance?month=${index+1}&year=${year}&page=${page}&per_page=${perPage}&search=${searchTerm}`)
                        .then(response => {
                        // const daily_accounts = response.data.data;
                        const trial = response.data.trial.data;   
                        const total_credit = response.data.total_credit;
                        const total_debit = response.data.total_debit;
                        const total_rec = response.data.trial.total;
                        const last_page = response.data.trial.last_page;   

                        setTotalPages(last_page);

                        setTotal(total_rec);
                            // console.log("income--------->",income);
                        setTrial(trial);
                        settotalCredit(total_credit);
                        settotalDebit(total_debit);
                        setHasFetched(true);
                        })
                        .catch(error => {
                        console.error('Error fetching Profit Loss!', error);
                        setHasFetched(true);
                        });
            }, [index, page, searchTerm, perPage]);

        //  useEffect(() => {
        //             axios.get(`${baseURL}/manage-trial-balance`)
        //                 .then(response => {
        //                 // const daily_accounts = response.data.data;
        //                 const trial = response.data.trial;   
        //                 const total_credit = response.data.total_credit;
        //                 const total_debit = response.data.total_debit;
        //                     // console.log("income--------->",income);
        //                 setTrial(trial);
        //                 settotalCredit(total_credit);
        //                 settotalDebit(total_debit);
        //                 setHasFetched(true);
        
        //                 })
        //                 .catch(error => {
        //                 console.error('Error fetching Profit Loss!', error);
        //                 setHasFetched(true);
        //                 });
        //             }, []);

   

    const [selectedOption, setSelectedOption] = useState(null);
    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(new Date());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(new Date());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());


    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custum Date" }
    ];

    const ledger_options = [
        { value: "all", label: "All" },
        { value: "0", label: "Expense" },
        { value: "1", label: "Income" },
    ];


    const subledger_options = [
        { value: "all", label: "All" },
        { value: "0", label: "Rent Expense" },
        { value: "1", label: "Raw Material Expense" },
        { value: "2", label: "By Subscriptions Income" },
    ];
// alert(total);
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Trial Balance</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Account Management</li>
                    </ol>
                </div>
                {/* {open && modalType === "View" && (
                    <View show={open} onClose={() => setOpen(false)} />
                )} */}
            </div>
            <div className='row'>
                <div className='col-lg-6'>
                    <div className='mb-3'>
                        <Carousel
                            controls={true}
                            activeIndex={index}
                            onSelect={handleSelect}  // Dynamically update the active index
                            indicators={true}
                            interval={null}
                             nextIcon={index === months.length - 1 ? null : undefined}
                        >
                             {months.map((month, idx) => (
                                                       <Carousel.Item key={idx} className='text-center'>
                                                           <label className='fs-3 text-black fw-bold'>{month}</label>
                                                           <div className='d-block'>
                                                               <label className='fs-3 text-danger fw-bold'>{year}</label>
                                                           </div>
                                                       </Carousel.Item>
                                                        ))}
                            {/* <Carousel.Item key={2} className='text-center'>
                                <label className='fs-3 text-black fw-bold'>February</label>
                                <div className='d-block'>
                                    <label className='fs-3 text-danger fw-bold'>2025</label>
                                </div>
                            </Carousel.Item>
                            <Carousel.Item key={3} className='text-center'>
                                <label className='fs-3 text-black fw-bold'>March</label>
                                <div className='d-block'>
                                    <label className='fs-3 text-danger fw-bold'>2025</label>
                                </div>
                            </Carousel.Item> */}
                        </Carousel>
                    </div>
                </div>
                <div className='col-lg-6'>
                    <div className='d-flex align-items-end justify-content-end'>
                        <div className='me-2'>
                            <div className='border rounded px-3 py-1 border-success bg-success-light'>
                                <label className='text-black fs-6'>Total Credit</label>
                                <div className='d-block text-center'>
                                    <label className="text-danger fs-3 m-0 fw-bold">
                                        <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                        <span>{total_credit}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='me-2'>
                            <div className='border rounded px-3 py-1 border-danger bg-danger-light '>
                                <label className='text-black fs-6'>Total Debit</label>
                                <div className='d-block text-center'>
                                    <label className="text-danger fs-3 m-0 fw-bold">
                                        <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                        <span>{total_debit}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="table-container">
                 <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>
                <table
                    ref={tableRef}
                    id="kt_datatable_responsive_approved"
                    className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"

                >
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th>Group</th>
                            <th>Ledger</th>
                            <th className='text-end'>Credit</th>
                            <th className='text-end'>Debit</th>
                            <th className='text-end'>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                         {trial.map(data => (  <>
                         <tr> 
                            {data.is_credit==0?(
                                 <>
                             <td>Expense</td>   
                            <td>
                                <label className='text-black font-w400 fs-7'>{data.subledger_name}</label>
                            </td>
                            <td className='text-end'>
                                -
                            </td>
                            <td className='text-end'>
                                <Badge bg="danger" className='py-0 px-1 fs-6'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>{data.amount}</span>
                                </Badge>
                            </td>
                            <td class="text-end">
                                <span >
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                         <Button variant="primary tp-btn-light px-2 py-1 me-1"  onClick={() => handleModalToggle_View(data.sno)} > 
                                            <span><i class="fa fa-eye fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </span>
                            </td>
                             </>
                        ):(<>
                        <td>Incomes</td> 
                            <td>
                                <label className='text-black font-w400 fs-7'>{data.subledger_name}</label>
                            </td>
                            <td className='text-end'>
                                <Badge bg="success" className='py-0 px-1 fs-6'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>{data.amount}</span>
                                </Badge>
                            </td>
                            <td className='text-end'>-</td>
                            <td class="text-end">
                                <span >
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_View(data.sno)}>
                                            <span><i class="fa fa-eye fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </span>
                            </td>
                             </>
                        )}
                        </tr>
                                </>
                            ))}   

                        {/* <tr>
                            <td></td>
                            <td>
                                <label className='text-black font-w400 fs-7'>By Subscriptions Income</label>
                            </td>
                            <td className='text-end'>
                                <Badge bg="success" className='py-0 px-1 fs-6'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>5000</span>
                                </Badge>
                            </td>
                            <td className='text-end'>
                                -
                            </td>
                            <td class="text-end">
                                <span >
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={handleModalToggle_View}>
                                            <span><i class="fa fa-eye  fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </span>
                            </td>
                        </tr>   */}
                    </tbody>
                </table>

                 {showModal && trialbalanceData && (
                                                <View
                                                    show={showModal}
                                                    onClose={handleCloseModal}
                                                    trialbalanceData={trialbalanceData}
                                                />
                                            )} 

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {trial.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + trial.length} of {total} entries
                            </span>
                        ):(
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                </div>

                {/* <div className='row d-flex justify-content-end mt-5'>
                    <div className='col-lg-4'>
                        <div className='row'>
                            <label className='col-lg-8 fs-5 font-w500 text-black'> Total for Credit</label>
                            <div className='col-lg-4 text-end'>
                                <label className='text-green font-w600 py-0 px-1 fs-4'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>30,000</span>
                                </label>
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <label className='col-lg-8 fs-5 font-w500 text-black'> Total for Debit</label>
                            <div className='col-lg-4 text-end'>
                                <label className='text-danger font-w600 py-0 px-1 fs-4'>
                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                    <span>50,000</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div> */}

            </div>

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Daily Accounts Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Ledger</label>
                                <Select
                                    defaultValue={ledger_options[0]}
                                    onChange={setSelectedOption}
                                    options={ledger_options}
                                    placeholder="Select Ledger"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Sub Ledger</label>
                                <Select
                                    defaultValue={subledger_options[0]}
                                    onChange={setSelectedOption}
                                    options={subledger_options}
                                    placeholder="Select Sub Ledger"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Ledger Account</label>
                                <input
                                    type='text'
                                    className='form-control'
                                    placeholder="Ledger Account"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={onClose}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={onClose}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>

        </>
    )


}
export default Trial_Balance;